import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Tooltip} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useAppSelector} from '../../../../hooks/runtime'
import {isEventPreview} from '../../../../selectors/navigation'
import {getPreliminaryInvoice} from '../../../../selectors/placed-order'
import {getSelectedTicketsQuantity} from '../../../../selectors/selected-tickets'
import {InnerSummary} from '../inner-summary'
import {StyledButton} from '../styled-button'
import {SummaryProps} from './interfaces'
import {classes} from './summary.st.css'

export const Summary = ({withoutBreakdown, inTickets, onCheckoutClick, onTicketSelectionError}: SummaryProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  const selectedTickets = useAppSelector(getSelectedTicketsQuantity)
  const invoice = useAppSelector(getPreliminaryInvoice)
  const eventPreview = useAppSelector(isEventPreview)

  return (
    <div className={classes.container}>
      {selectedTickets || inTickets ? (
        <InnerSummary invoice={invoice} withoutBreakdown={withoutBreakdown} selectedTicketsQuantity={selectedTickets} />
      ) : (
        t('seatings_selectTickets')
      )}
      <CheckoutButton
        onCheckoutClick={onCheckoutClick}
        previewCheckout={eventPreview}
        isMobile={isMobile}
        inTickets={inTickets}
        selectedTickets={selectedTickets}
        t={t}
        onTicketSelectionError={onTicketSelectionError}
      />
    </div>
  )
}

const CheckoutButton = ({
  previewCheckout,
  onCheckoutClick,
  inTickets,
  selectedTickets,
  isMobile,
  t,
  onTicketSelectionError,
}) => {
  if (!onCheckoutClick) {
    return null
  }

  const getCheckoutText = () => {
    if (!isMobile) {
      return t('seatings_desktopCheckout')
    }

    return inTickets ? t('seatings_continueToCheckout') : t('seatings_checkout')
  }

  const buttonDisabled = inTickets && previewCheckout

  const button = (
    <StyledButton
      dataHook={inTickets ? DH.CHECKOUT : DH.REVIEW_AND_CHECKOUT}
      disabled={buttonDisabled}
      onClick={() => {
        if (onTicketSelectionError && !selectedTickets) {
          onTicketSelectionError()
          return
        }
        onCheckoutClick()
      }}
    >
      {getCheckoutText()}
    </StyledButton>
  )

  if (previewCheckout) {
    return (
      <Tooltip content={t('draftEventPreviewTooltip')} fluid={true}>
        {button}
      </Tooltip>
    )
  }

  return button
}
